import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import { API_URL } from './api.js'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    status: "",
    token: localStorage.getItem("token") || "",
    user: {}
  },
  mutations: {
    auth_request(state) {
      state.status = "loading";
    },
    auth_success(state, token, user) {
      state.status = "success";
      state.token = token;
      state.user = user;
    },
    auth_error(state) {
      state.status = "error";
    },
    logout(state) {
      state.status = "";
      state.token = "";
    }
  },
  actions: {
    register({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios({
          url: `${API_URL}/users`,
          data: user,
          method: "POST",
          withCredentials: true
        })
          .then(resp => {
            const token = resp.headers['x-auth'];
            const user = resp.data.user;
            localStorage.setItem("access", JSON.stringify([]));
            localStorage.setItem("restaurantId", null);
            localStorage.setItem("token", token);
            axios.defaults.headers.common["x-auth"] = token;
            commit("auth_success", token, user);
            resolve(resp);
          })
          .catch(err => {
            commit("auth_error", err);
            localStorage.removeItem("token");
            reject(err);
          });
      });
    },
    login({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios({
          url: `${API_URL}/session`,
          data: user,
          method: "POST",
          withCredentials: true
        })
          .then(resp => {
            const token = resp.headers['x-auth'];
            const user = resp.data.user;
            const access = resp.data.access
            localStorage.setItem("access", JSON.stringify(access));

            if (localStorage.getItem("restaurantId") && (access.findIndex(e => e.restaurantId === localStorage.getItem("restaurantId")) !== -1)) console.log('restaurantId ok!')
            else if (access[0]) localStorage.setItem("restaurantId", access[0].restaurantId);
            else localStorage.setItem("restaurantId", null);

            localStorage.setItem("token", token);
            axios.defaults.headers.common["x-auth"] = token;
            commit("auth_success", token, user);
            resolve(resp);
          })
          .catch(err => {
            console.log(err)
            commit("auth_error");
            localStorage.removeItem("token");
            reject(err);
          });
      });
    },
    logout({ commit }) {
      return new Promise((resolve, reject) => {
        axios({
          url: `${API_URL}/session`,
          method: "DELETE",
          withCredentials: true
        })
          .then(resp => {
            commit("logout");
            localStorage.removeItem("token");
            delete axios.defaults.headers.common["x-auth"];
            resolve(resp);
          })
          .catch(err => {
            commit("auth_error");
            localStorage.removeItem("token");
            reject(err);
          });
      });
    }
  },
  getters: {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status
  }
});
